// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSConfig.custom.products_per_page,
		// Optional
		loadProductFirst: true,
		activeFilterScrollbar: 'browser'
	}
};

// Declare Templates
var boostPFSTemplate = {
	// Grid Template
	'productGridItemHtml':  '<article class="product--root" {{dataHoverImage}}>' +
								'{{itemLabels}}' +
								'<a href="{{itemUrl}}">' +
									'<div class="product--image-wrapper">' +
										'<div class="product--image">' +
											'{{itemImage}}' +
										'</div>' +
										'{{itemHoverImage}}' +
									'</div>' +
								'</a>' +
								'<div class="product--details">' +
									'<a href="{{itemUrl}}">' +
										'<div class="product--title">{{itemTitle}}</div>' +
									'</a>' +
									'{{itemVendor}}' +
									'<a href="{{itemUrl}}">' +
										'<div class="product--price-wrapper">' +
											'{{itemPrice}}' +
										'</div>' +
									'</a>' +
								'</div>' +
							'</article>',
	// Pagination Template
	'previousActiveHtml': '<li class="arrow left"><a href="{{itemUrl}}"><span class="glyph arrow-left" aria-hidden="true"></span> '+ boostPFSConfig.label.pagination_previous +'</a></li>',
	'previousDisabledHtml': '<li class="arrow left unavailable"><a href=""><span class="glyph arrow-left" aria-hidden="true"></span> '+ boostPFSConfig.label.pagination_previous +'</a></li>',
	'nextActiveHtml': '<li class="arrow right"><a href="{{itemUrl}}">'+ boostPFSConfig.label.pagination_next +' <span class="glyph arrow-right" aria-hidden="true"></span></a></li>',
	'nextDisabledHtml': '<li class="arrow right unavailable"><a href="">'+ boostPFSConfig.label.pagination_next +' <span class="glyph arrow-right" aria-hidden="true"></span></a></li>',
	'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
	'pageItemSelectedHtml': '<li class="current"><a href="">{{itemTitle}}</a></li>',
	'pageItemRemainHtml': '<li class="unavailable"><a href="">{{itemTitle}}</a></li>',
	'paginateHtml': '{{previous}}{{pageItems}}{{next}}',

	// Sorting Template
	'sortingHtml': '<label for="boost-pfs-filter-top-sorting-select">' + boostPFSConfig.label.sorting + '</label><select class="boost-pfs-filter-top-sorting-select">{{sortingItems}}</select>',
};


(function () {
	BoostPFS.inject(this);

	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

	
		// Add data hover image
		var dataHoverImage = boostPFSConfig.custom.hover_image_enable ? 'data-hover-image="true"' : '';
		itemHtml = itemHtml.replace(/{{dataHoverImage}}/g, dataHoverImage);

		// Add Labels
		var itemLabelsHtml = '';
		if (soldOut) {
			itemLabelsHtml += '<a href="{{itemUrl}}">';
			itemLabelsHtml += '<div class="product--sold-out"><span>';
			itemLabelsHtml += boostPFSConfig.label.sold_out;
			itemLabelsHtml += '</span></div>';
			itemLabelsHtml += '</a>';
		} else if (onSale) {
			itemLabelsHtml += '<a href="{{itemUrl}}">';
			itemLabelsHtml += '<div class="product--sale" href=""><span>';
			itemLabelsHtml += boostPFSConfig.label.sale;
			itemLabelsHtml += '</span></div>';
			itemLabelsHtml += '</a>';
		}
		itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

		// Add Image
		itemHtml = itemHtml.replace(/{{itemImage}}/g, buildItemImage(data, 'image'));
	
		// Add Vendor
		var itemVendorHtml = '';
		if (boostPFSConfig.custom.vendor_enable) {
			itemVendorHtml += '<p class="vendor"><a href="' + this.buildProductItemVendorUrl(data.vendor) + '">' + data.vendor + '</a>'
		}
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var itemPriceHtml = '';
		if (onSale) {
			itemPriceHtml += '<span class="product--compare-price">' + 
								'<span class="money">' + Utils.formatMoney(data.compare_at_price_min) + '</span>' +
							'</span>' +
							'<span class="product--price">' +
								'<span class="money">' + Utils.formatMoney(data.price_min) + '</span>' +
							'</span>';
		} else {
			if (priceVaries) {
				itemPriceHtml += '<span class="product--from">' + boostPFSConfig.label.from_price + '</span>';
			}
			itemPriceHtml += '<span class="product--price"><span class="money">' + Utils.formatMoney(data.price_min) + '</span></span>';
		}
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Hover Image
		var itemHoverImage = boostPFSConfig.custom.hover_image_enable ? buildItemImage(data, 'hover') : '';
		itemHtml = itemHtml.replace(/{{itemHoverImage}}/g, itemHoverImage);

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	};

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {

		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);


		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml :  boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage in pageArr) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}

		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {

			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content 
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
				}
				var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
				return html;
			}
		}

		return '';
	};

	// Build srcset
	// @data = data.images_info
	function getSrcsetUrl(data) {
		var arr = [];
		var listImageWidth = getListImageWidth(data);
		var len = listImageWidth.length;
		var url = '';

		if (data != null) {
			for (var i = 0; i < len; i++) {
				url = data.src.substring(0, data.src.lastIndexOf('.'));
				url += '_' + listImageWidth[i] + 'x';
				url += data.src.substring(data.src.lastIndexOf('.'));
				url += ' ' + listImageWidth[i] + 'w';
				arr.push(url);
			}
		}

		return arr;
	}

	// Get Aspect Ratio based on Dimensions
	// @data = data.images_info
	function getAspectRatio(data) {
		var width = (data == null) ? '600' : data.width;
		var height = (data == null) ? '400' : data.height;
	
		return width / height;
	}

	// Get Image Width List
	// @data = data.images_info
	function getListImageWidth(data) {
		var arr = [295, 394, 590, 700, 800, 1000, 1200, 1500, 1800, 2000, 2400];
		var arr_len = arr.length;
		var rs = [];
	
		if (data != null) {
			for (var i = 0; i < arr_len; i++) {
				var width_init = arr[i] + 0;

				if (data.width > width_init) {
					rs.push(width_init);
				}
			}
			rs.push(data.width);
		}

		return rs;
	}

	function buildItemImage(data, type) {
		var itemImage = '';
		var index = Object.keys(data.images);
		var imgWidth = (data.images_info[0] == null) ? '600' : data.images_info[0].width;

		// Calculate padding-top based on aspect ratio
		var pad_top = 1 / getAspectRatio(data.images_info[0]) * 100;

		// Image Section
		if (type !== 'image') {
			itemImage += '<div class="product--hover-image">';
		}

		itemImage += '<div class="image--root" data-aspectratio="' + getAspectRatio(data.images_info[0]) + '" style="width:' + imgWidth + 'px">';
		itemImage += '<div class="image--container" style="padding-top:' + pad_top + '%">';
	
		// Get image src (type='image') & hover image src
		if (type === 'image') {
			if (index.length > 0) {
				itemImage += '<img class="lazyload" data-sizes="auto" data-widths="[' + getListImageWidth(data.images_info[0]) 
							+ ']" src="' + data.images[1] 
							+ '" data-src="' + getSrcsetUrl(data.images_info[0])
							+ '" srcset="' + getSrcsetUrl(data.images_info[0])
							+ '" alt="' + data.title + '">';
			} else { 
				itemImage += '<img class="lazyload" data-sizes="auto" data-widths="[' + getListImageWidth(data.images_info[0]) 
							+ ']" src="' + boostPFSConfig.general.no_image_url 
							+ '" data-src="' + getSrcsetUrl(data.images_info[0])
							+ '" srcset="' + getSrcsetUrl(data.images_info[0])
							+ '" alt="' + data.title + '">';
			}   
		} else {    
			if (index.length > 0) {
				itemImage += '<img class="lazypreload" data-sizes="auto" data-widths="[' + getListImageWidth(data.images_info[0]) 
							+ ']" src="' + data.images[index.length] 
							+ '" data-src="' + getSrcsetUrl(data.images_info[data.images_info.length - 1])
							+ '" srcset="' + getSrcsetUrl(data.images_info[data.images_info.length - 1])
							+ '" alt="' + data.title + '">';
			} else {
				itemImage += '<img class="lazyload" data-sizes="auto" data-widths="[' + getListImageWidth(data.images_info[0]) 
							+ ']" src="' + boostPFSConfig.general.no_image_url 
							+ '" data-src="' + getSrcsetUrl(data.images_info[data.images_info.length - 1])
							+ '" srcset="' + getSrcsetUrl(data.images_info[data.images_info.length - 1])
							+ '" alt="' + data.title + '">';
			}   
		}  
	
		if (type !== 'image') {
			itemImage += '</div>';
		}
		itemImage += '</div></div>';

		return itemImage; 
	}

	// Build additional attributes of product items
	ProductList.prototype.afterRender = function(data) {

		if (!data) data = this.data;
		jQ(".product--image-wrapper").each(function() {
			jQ(this).on('mouseover mouseout', function() {
				var item = jQ(this).children('.product--hover-image');

				if (item.length > 0) {
					if (event.type == 'mouseover') {
						jQ(item).attr('style', 'opacity: 1');
					} else {
						jQ(item).attr('style', 'opacity: 0');
					}
				}
			});
		});
	};

	// Build additional elements
	FilterResult.prototype.afterRender = function(data, eventType) {};

})();